import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal, Col, Row, Button } from "antd";
import { Dispatch, SetStateAction, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleMakePayment } from "../../CheckoutNew";
import { useMutation } from "react-query";
import { Sale, createSale } from "../../../../api/sales";
import { mainActions } from "../../../../store/main/mainSlice";
import { exchangeRateContext } from "../../MainFour";
import { useTranslation } from "react-i18next";

interface props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setIsOpenProceed: React.Dispatch<React.SetStateAction<boolean>>;
}

export const OnAccount = ({ isOpen, setIsOpen, setIsOpenProceed }: props) => {
  const items = useSelector((state: any) => state.main.items);
  const customer = useSelector((state: any) => state.main.customer);
  const discount = useSelector((state: any) => state.main.discount);
  const finalPrice = useSelector((state: any) => state?.main?.finalPrice);
  const mainCurrencyString = localStorage.getItem("mainCurrency");
  const mainCurrency = mainCurrencyString
    ? JSON.parse(mainCurrencyString)
    : null;
  const sessionId = useRef(localStorage.getItem("sessionId"));
  const { mutateAsync: createSaleMutation, isLoading } = useMutation(
    "createSale",
    (body: Sale) => createSale(body)
  );
  const invoiceNo = useSelector((state: any) => state.main.invoiceNo);
  const { exchangeRate } = useContext(exchangeRateContext);
  const dispatch = useDispatch();

  const [t] = useTranslation("common");

  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        onCancel={() => {
          setIsOpen(false);
        }}
        open={isOpen}
        centered
        footer={[
          <Button
            key="cancel-button"
            onClick={() => {
              setIsOpen(false);
            }}
            style={{
              color: "#1677FF",
              border: "1px solid #1677FF",
              marginInlineEnd: "auto",
              height: "40px",
            }}
          >
            {t("cancel")}
          </Button>,
          <Button
            key="confirm-button"
            htmlType="submit"
            style={{
              background: "#1677FF",
              color: "#fff",
              height: "40px",
              border: "none",
            }}
            onClick={() =>
              handleMakePayment(
                false,
                null,
                items,
                createSaleMutation,
                customer,
                discount,
                mainCurrency,
                sessionId,
                invoiceNo,
                exchangeRate
              ).then((res) => {
                setIsOpen(false);
                dispatch(mainActions.clearInvoice());
                setIsOpenProceed(false);
                dispatch(
                  mainActions.setInvoiceType({
                    id: null,
                    typeName: null,
                    isActive: null
                  })
                )
                dispatch(
                  mainActions.addDelivery({
                    deliveryCharge: null,
                    deliveryLocation: {
                      id: null,
                      location: null
                    },
                    deliveryChargeText: null
                  })
                )
                document.body.classList.remove("body-scroll-lock");
              })
            }
          >
            {t("confirm")}
          </Button>,
        ]}
        title={
          <Row>
            <Col span={3}>
              <ExclamationCircleFilled
                style={{
                  color: "#FFBC39",
                  fontSize: "45px",
                  marginTop: "22px",
                }}
              />
            </Col>
            {
              <Col
                span={19}
                style={{
                  fontSize: "32px",
                  color: "#212121",
                }}
              >
                {t("confirm-debit")}
                <Col
                  span={19}
                  style={{
                    fontSize: "16px",
                    color: "#212121",
                  }}
                >
                  {`${t('please-confirm-debiting')} ${customer?.name} ${t("with-total-payment")} ${finalPrice}${mainCurrency?.symbol}`}
                </Col>
              </Col>
            }
          </Row>
        }
      />
    </>
  );
};
